import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=cf8f9d2a&"
import script from "./CartView.vue?vue&type=script&lang=ts&"
export * from "./CartView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports